<template>
  <div class="wrapper">
    <HeaderView />

    <section class="content">
      <router-view />
    </section>

    <FooterView />
  </div>
</template>

<script>
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView
  },
  mounted() {
    this.observedElements = new Set()

    const wrapSectionTitles = () => {
      document.querySelectorAll('.section__title').forEach(el => {
        if (!el.dataset.emWrapped) {
          const childNodes = Array.from(el.childNodes)
          const lines = []
          let currentLine = []

          childNodes.forEach(node => {
            if (node.nodeName === 'BR') {
              lines.push(currentLine)
              currentLine = []
            } else {
              currentLine.push(node)
            }
          })
          lines.push(currentLine)

          el.innerHTML = ''

          lines.forEach((lineNodes, i) => {
            const em = document.createElement('em')
            lineNodes.forEach(n => em.appendChild(n))
            el.appendChild(em)
            if (i !== lines.length - 1) {
              el.appendChild(document.createElement('br'))
            }
          })

          el.dataset.emWrapped = 'true'
        }
      })
    }

    wrapSectionTitles()

    const handleSectionTitle = (el) => {
      el.classList.add('section__title_show')
    }

    const handleFadeIn = (el) => {
      el.classList.add('fadeIn_active')
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target

          if (el.classList.contains('section__title')) {
            handleSectionTitle(el)
          } else if (el.classList.contains('fadeIn')) {
            handleFadeIn(el)
          }

          this.observer.unobserve(el)
          this.observedElements.delete(el)
        }
      })
    }, {threshold: 0.1})

    const observeElements = () => {
      document.querySelectorAll('.section__title').forEach(el => {
        if (!this.observedElements.has(el)) {
          this.observer.observe(el)
          this.observedElements.add(el)
        }
      })
      document.querySelectorAll('.fadeIn:not(.section__title)').forEach(el => {
        if (!this.observedElements.has(el)) {
          this.observer.observe(el)
          this.observedElements.add(el)
        }
      })
    }

    observeElements()

    this.mutationObserver = new MutationObserver(() => {
      wrapSectionTitles()
      observeElements()
    })

    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    })
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }
  }
}
</script>
